/**
 * Helper function for removing props whose values are `undefined`
 *
 * Returns a new object.
 *
 * @remarks Shallow - won't affect nested objects
 */
export function omitUndefined<E extends object>(obj: E): OmitUndefined<E> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const result = {} as any;

  for (const key in obj) {
    const value = obj[key];
    if (typeof value !== 'undefined') {
      result[key] = value;
    }
  }

  return result;
}
